
export const CONFIG = {
    TOMMY_API_URL: process.env.REACT_APP_TOMMY_API_URL,
    LSGENIUS_URL: process.env.REACT_APP_LSGENIUS_URL,
    FOOTER_HEIGHT: 15,
};